"use strict";

module.exports = /*@ngInject*/function () {
  return function (input) {
    return input.replace(/_/g, ' ').toLowerCase();
  };
};